import { render, staticRenderFns } from "./OrderActivity.vue?vue&type=template&id=6da02c80&"
import script from "./OrderActivity.vue?vue&type=script&lang=js&"
export * from "./OrderActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports